import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-primary-text',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './primary-text.component.html',
  styleUrl: './primary-text.component.scss'
})
export class PrimaryTextComponent {
  @Input() fontSize: string = "16px"
  @Input() lineHeight: number = 1.8;
  @Input() lineHeightMobile: number = 1.8;
  @Input() mt: string = "0px";
  @Input() mb: string = "24px";

}
